//@flow
import React from 'react';
import { Container } from 'flux/utils';
import Stars from './Stars';
import ProductsStore from '../js/Stores/Products/products';

import type {ReviewSummaryObject} from '../js/Stores/Products/reviewSummaryModel';
import type ProductModel from '../js/Stores/Products/productModel';

const MIN_PRODUCT_REVIEWS = 5;

export const shouldShowReviews = (reviewsCount:number) => {
  return reviewsCount >= MIN_PRODUCT_REVIEWS;
};

const summaryHolder = (productSku:string) => {
  return {
    productSku,
    rating: 0,
    total: 0,
  };
};

type Props = {
  product:ProductModel,
  clickable?:boolean,
  longLabel?:boolean,
};

type State = {
  reviewSummary?:ReviewSummaryObject|null,
};

// NOTE: component name `ProductReviewSummaryComponent` doesn't
// match file name because model with same name is used here

class ProductReviewSummaryComponent extends React.Component<Props, State> {
  static getStores() {
    return [
      ProductsStore,
    ];
  }

  static calculateState(prevState:State, props:Props):State {
    const reviewSummary = ProductsStore.getProductReviewSummary(props.product);
    return {
      reviewSummary,
    };
  }

  static defaultProps = {
    longLabel: true,
  }

  render() {
    const reviewSummary = this.state.reviewSummary || summaryHolder(this.props.product.getSku());

    if (!reviewSummary ) {
      return null;
    }
    // Do not render unless sku is whitelisted
    else if (reviewSummary && !shouldShowReviews(reviewSummary.total)) {
      return null;
    }

    const {
      rating,
      total,
    } = reviewSummary;

    let totalLabel = '';
    if (this.props.longLabel) {
      totalLabel = total === 1
        ? `${total} rating`
        : `${total} ratings`;
    } else {
      totalLabel = `${total}`;
    }

    const ratingLabel = (rating / 20).toFixed(1);

    const classes = ['product-review-summary'];
    if (!this.props.clickable) classes.push('no-click');
    const cls = classes.join(' ');

    return (
      <div className={cls}>
        <h3 className="rating-container">
          {ratingLabel}
        </h3>
        <div className="stars-container">
          <Stars rating={rating} />
        </div>
        <div className="total-container">
          ({totalLabel})
        </div>
      </div>
    );
  }
}

export default Container.create(ProductReviewSummaryComponent, {
  pure: false,
  withProps: true,
});
